import {
    signInWithRedirect,
    signOut,
    getCurrentUser,
    fetchAuthSession,
  } from "aws-amplify/auth";
  
  export async function login() {
    await signInWithRedirect();
  }
  
  export async function logout() {
    await signOut();
  }
  
  export async function getCurrentAdminStatus() {
    try {
      await getCurrentUser();
  
      const session = await fetchAuthSession();
      const groups =
        session?.tokens?.accessToken?.payload?.["cognito:groups"] || [];
  
      return {
        authenticated: true,
        isAdmin: Array.isArray(groups) && groups.includes("admin"),
        session,
      };
    } catch {
      return {
        authenticated: false,
        isAdmin: false,
        session: null,
      };
    }
  }
  
  export async function getAccessToken() {
    const session = await fetchAuthSession();
    return session?.tokens?.accessToken?.toString() || null;
  }